import React, { FC, useState } from 'react';
import { Form, Row, Col } from 'antd';

import { Card, Button, Kv } from '@comps';
import { Http, Context, Message } from '@utils';

export interface Props {
  onCancel: () => void;
  onConfirm: () => void;
};

const { Item } = Form;

const SwitchRole: FC<Props> = ({
  onCancel, 
  onConfirm,
}) => {

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleSave = async () => {
    await form.validateFields();
    setLoading(true);

    try {
      const roleId = form.getFieldValue("roleId");
      await Http.get(`/sys/users/switchRole?roleId=${roleId}&_=${Date.now()}`, undefined, { 'Cache-Control': 'no-cache' });
      await Context.initUserContext();
      Message.success("切换成功");
      onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card 
      title="切换角色" 
      loading={loading}
    >
      <Form form={form}>
        <Item 
          label='请选择角色' 
          name="roleId" 
          rules={[{ required: true }]}
        >
          <Kv url='/sys/users/roleKv' />
        </Item>
      </Form>
      <Row>
        <Col offset={10} span={10}>
          <Button 
            type="primary" 
            clickCallback={handleSave}
          >
            确认切换
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default SwitchRole;
